import './_styles.scss';
import React from 'react';
import Image from './Image';
import numeral from 'numeral';
import { Rating } from "components";

export default class Header extends React.Component {

  constructor(props) {

    super(props);

    this.state = { image: null, product: {} };

    this.add_to_cart = this.props.addToCart;

  }

  price = (amount) => numeral(amount).format('0,0');

  update_state = (props) => {

    const { images } = props.product || {};

    const image_url = (!!images) ? images[0] : '';

    this.setState({ image: image_url, product: props.product });

  }

  change_active_image = (image_url) => {

    if (!image_url) return null;

    if (image_url===this.state.image) return;

    return this.setState({ image: image_url });

  }

  componentDidMount = () => this.update_state(this.props);

  componentWillReceiveProps = (props) => {

    const { title } = this.state.product;

    if (title === props.product.title) return;

    return this.update_state(props);

  }

  render() {

    const { product } = this.state;

    const { pricing = {} } = product || {};

    return (
      <div className='Product-Details-Header'>
        <div className="Wrapper">

          <Image
            data={product.images}
            active={this.state.image}
            onChange={(e) => this.change_active_image(e)}
          />

          <div className="Product-Content">

            <div className="Product-Name">
              {this.state.product.title}
            </div>

            <Rating className='Product-Rating'/>

            <div className="Product-Description">
              {this.state.product.description}
            </div>

            <div className="Product-Price-Discounted">
              {this.price(pricing.price)} KES
            </div>

            { (pricing.compare > 0) &&
              <div className="Product-Price-Actual">
                Ksh {this.price(pricing.compare)}
              </div>
            }

            <button className="Cart-Button" onClick={()=>this.add_to_cart()}>
              Add to Cart
            </button>

          </div>

        </div>
      </div>
    )
  }
}
